import { Component, Input, OnInit } from '@angular/core';
import { SeatMap } from '@app/models/seatMap.model';
import {VenezuelaModalComponent} from "@modals/venezuela-modal/venezuela-modal.component";
import {NgbModal} from "@ng-bootstrap/ng-bootstrap";
import {SeatBenefitsModalComponent} from "@modals/seat-benefits-modal/seat-benefits-modal.component";

@Component({
    selector: 'app-am-plane-fare-info',
    templateUrl: './am-plane-fare-info.component.html',
    styleUrls: ['./am-plane-fare-info.component.scss'],
    standalone: false
})
export class AmPlaneFareInfoComponent implements OnInit {
 @Input() icon = '';
  @Input() fareImage = '';
  @Input() fareName = '';
  @Input() positionClass = '';
  @Input() seatMapSegment: SeatMap[] = [];
  constructor(private modalService: NgbModal) { }

  ngOnInit(): void {
  }

  openBenefits() {
    console.log("Beneficios: ",this.fareName)
    const modalRef = this.modalService.open(SeatBenefitsModalComponent, {
      fullscreen: true,
      centered: true,
      keyboard: false,
      backdrop: false,
    });
    modalRef.componentInstance.titleError = '';
    modalRef.componentInstance.msgError = '.subtitle';
    modalRef.componentInstance.printCard = '';
    modalRef.componentInstance.codeError = '';
    modalRef.componentInstance.uuidError = '';
    modalRef.componentInstance.backgroundColorModal = 'am-blue-premium';
    modalRef.componentInstance.showButton = false;
    modalRef.componentInstance.showIconImage = false;
    modalRef.componentInstance.colorFontButton = 'blue-font';
    modalRef.componentInstance.backGroundButton = 'search-bg';
    modalRef.componentInstance.sizeModal = 'lg900';
    modalRef.componentInstance.fontWeightTitleError = '500';
    modalRef.componentInstance.image = '';
    modalRef.componentInstance.showCancelButton = false;
    modalRef.componentInstance.cancelButtonText = '';
    modalRef.componentInstance.fareName = this.fareName;
  }

}
